import { Component, Input } from '@angular/core';

@Component({
  selector: 'mapv2-loader',
  templateUrl: './mapv2-loader.component.html',
  styleUrls: ['./mapv2-loader.component.scss']
})
export class MapV2LoaderComponent {
  @Input()
  public show: boolean = true;
  
  @Input() 
  public size: number = 32;

  @Input() 
  public fill: string = '#FFFFFF';

  @Input() 
  public weight: number = 3;

  constructor() { }
}